// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"359":"6d44b5d2","787":"99e8308e"}[chunkId] + ".chunk.js";
};